import React, { useContext, useEffect, useState } from "react";
import b from "../../assets/images/bg_blog.jpg";
import MasterLayout from "../../layout/MasterLayout";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import Post from "../../components/cards/Post";
import AppContext from "../../context/AppContext";
import { onPageHeadSEO, scrollToTop } from "../../helper/HelperFunctions";
import AnimationOnScroll from "../../components/AnimationOnScroll/AnimationOnScroll";
import axios from "axios";

const Posts = () => {
  const { baseUrl } = useContext(AppContext);
  const [posts, setPosts] = useState([]);
  const [loadingPosts, setLoadingPosts] = useState(true);

  const getAllPosts = () => {
    const formData = new FormData();

    axios
      .post(`${baseUrl}/api/guest/getPosts`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((resp) => {
        console.log(resp.data);
        setPosts(resp.data.posts);
        setLoadingPosts(false);
      })
      .catch((error) => {
        console.log(error);
        setLoadingPosts(false);
      });
  };

  useEffect(() => {
    scrollToTop();
    getAllPosts();
    onPageHeadSEO(
      "FixTech Expert",
      "FixTechExpert - book your repair with upto 30% discount.",
      "FixtechExpert,Discounted Repairing"
    );
  }, []);

  return (
    <MasterLayout>
      {/* Banner */}
      <Container
        fluid
        className="m-0 p-0 banner-image"
        style={{ backgroundImage: `url(${b})` }}
      >
        <Container fluid className="m-0 p-0 overlay">
          <h6 className="caption poppins-semiBold ">Read about</h6>

          <h1 className={`text-light poppins-bold res-heading`}>
            <span className="txt-green">FixTech Expert</span>{" "}
            {/* <h6 className="caption poppins-semiBold text-center mt-2">
              24/7 discounted Taxi Service
            </h6> */}
          </h1>
        </Container>
      </Container>
      {/* What we offer you - Posts */}
      <Container fluid className="m-0 my-2 py-5">
        {loadingPosts ? (
          <div style={{ height: "30vh", width: "100%" }}>
            <Spinner
              size={"lg"}
              color="#000"
              style={{ marginLeft: "50%", marginTop: "5%" }}
            />
          </div>
        ) : (
          <Row className="m-0 px-5">
            {posts.length > 0 ? (
              posts.map((item, index) => (
                <Col
                  xs={12}
                  lg={4}
                  className="m-0 p-0 d-flex justify-content-center"
                  key={index}
                >
                  <Post item={item} />
                </Col>
              ))
            ) : (
              <h1 className="caption poppins-semiBold text-center mt-2">
                No Posts Available.
              </h1>
            )}
          </Row>
        )}
      </Container>
    </MasterLayout>
  );
};

export default Posts;
